import { Component, OnInit, ViewChild, ElementRef }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IScenario, ScenarioService } from './scenario.service';
import { UserSession } from '../shared/user-session';
import { AuthService } from '../authentication/auth.service';
import { UserInfoService } from '../shared/user-info.service';

@Component({
    template: require('./scenario-activities.component.html'),
    styles: [require('../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES],
})

export class ScenarioActivitiesComponent implements OnInit{
    pageTitle: string = 'Scenario Activities';
    errorMessage: string;
    allScenarios: IScenario[];
    currentScenario: IScenario;
    scenarioHeaderDiv: HTMLDivElement;
    
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _scenarioService: ScenarioService,
                private _User: UserSession,
                private authService: AuthService,
                private _userInfoService: UserInfoService) {
    }
    @ViewChild('scenarioHeader') scenarioHeader: ElementRef;

    ngOnInit(): void{

      this._scenarioService.getScenarios(this._User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    if (this._User.hasValidSession()){
                        console.log("this._User " + this._User.getSession().scenarioId);
                        this.setScenarioHeader(this._User.getSession().scenarioId);
                    }
                    else {
                        this.setScenarioHeader(this._User.scenarioId);
                        this._User.updateSessionState();
                    }
                }
            );
      this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
    
      if(typeof(this._User.scenarioId) === 'undefined')
        this.router.navigate(['./scenario-activities']);

    }
    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
        this.scenarioHeaderDiv.innerHTML = `<strong>Current Scenario: ${this.currentScenario.scenarioName} (${this.currentScenario.id})</strong>`;
    }
}



/** WEBPACK FOOTER **
 ** ./app/scenario-activities/scenario-activities.component.ts
 **/